import AutoCompleteUIDTO from "../dto/AutoCompleteUIDTO";
import NotificationService from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/NotificationService";
import { WorklogReportExport, WorklogReportExportExtension } from "../types/WorklogReportExport";
import { MONTH_NAMES } from "./OpsDateUtils";

export const generateReportAndDownload = (
  // @ts-ignore
  worklogReportType: WorklogReportExport,
  selectedDate: Date | null,
  search: AutoCompleteUIDTO,
  userExternalId?: string,
  unified: boolean = false
): Promise<any> => {
  const reportRequest = WorklogReportExport[worklogReportType];
  const year: number = selectedDate ? selectedDate.getFullYear() : new Date().getFullYear();
  const month: number = selectedDate ? selectedDate.getMonth() : new Date().getMonth();

  return new Promise((resolve, reject) => {
    reportRequest(search.externalId, year, month, userExternalId, unified)
      .then((response) => {
        download(response, generateReportLabel(search, worklogReportType, MONTH_NAMES[month], year));
        NotificationService.info("Report download successfully!");
        resolve(0);
      })
      .catch((err: any) => {
        if (err && err.message) {
          NotificationService.error(err.message);
        } else {
          NotificationService.error("Failed to download report.");
        }
        reject(err);
      });
  });
};

// @ts-ignore
const generateReportLabel = (search: any, worklogReportType: WorklogReportExport, monthName: string, year: number): string => {
  const reportKey = Object.entries(WorklogReportExport).find(([key, value]) =>
    value === WorklogReportExport[worklogReportType] ? key : undefined
  )?.[0];
  return `${search.label}-${monthName}-${reportKey}-${year}${WorklogReportExportExtension[worklogReportType]}`;
};

const download = (response: any, label: string): void => {
  const url = window.URL.createObjectURL(new Blob([response]));
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", label);
  document.body.appendChild(link);
  link.click();
};

export function randomId(): string {
  const uint32 = window.crypto.getRandomValues(new Uint32Array(1))[0];
  return uint32.toString(16);
}
